module.exports = __webpack_public_path__ + "static/media/ice21.4693323f.webp";